import { useEffect, useState } from 'react'
import { isLoggedIn, signInAnonymouslyH2H } from '@/firebase/auth'
import { shellStore } from '@/store/shellStore'

/* Port of Tracking/TrackingCopy's SchedulerBinding.addPostFrameCallback:
 *
 *   if (!loggedIn) {
 *     GoRouter.of(context).prepareAuthEvent();
 *     final user = await authManager.signInAnonymously(context);
 *     if (user == null) { return; }        // <- page stays in loader FOREVER
 *   }
 *   _model.initialized = true; safeSetState(() {});
 *
 * prepareAuthEvent mutes the router rebuild the sign-in emission would
 * trigger, so the page is not unmounted mid-await.
 *
 * PARITY: a failed sign-in leaves initialized false forever — endless
 * AppLoading, no error text, no retry. Faithfully preserved. */

export function useAnonymousAuth(
  onError?: (message: string) => void,
): boolean {
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    let alive = true
    void (async () => {
      if (!isLoggedIn()) {
        shellStore.prepareAuthEvent()
        const user = await signInAnonymouslyH2H(onError)
        if (user == null) return // parity: stuck in loader
      }
      if (alive) setInitialized(true)
    })()
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return initialized
}
